import React from 'react'
import { HotkeysTarget2 } from "@blueprintjs/core";


function DoneProspHK({doneProsp}) {

    const hotkeys = [
        {
            combo: "d",
            global: true,
            label: "Done",
            onKeyDown: doneProsp,
        },
        // {
        //     combo: "ctrl + c",
        //     global: true,
        //     label: "Copy",
        //     onKeyDown: copyFunc,
        // },
    ]

    return (
        <HotkeysTarget2 hotkeys={hotkeys}>
        {({ handleKeyDown, handleKeyUp }) => (
            <div onKeyDown={handleKeyDown} onKeyUp={handleKeyUp}>
                
            </div>
        )}
        </HotkeysTarget2>   
    )
}

export default DoneProspHK
